<template>
<div>
   <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title id="dr_title_Send">Web Cam</md-dialog-title>

      <md-dialog-content>
         <div style="margin-top:5px;">
            <!--
            <md-textarea v-model="bolval" rows="1">
            </md-textarea>  
            <md-input-container class="md-block">
               <textarea v-model="bolval" md-maxlength="350" cols="50" md-select-on-focus md-no-autogrow>
               </textarea>   
            </md-input-container>   
            -->
            <md-field style="width:300px">
               <label>BOL Number</label>
               <md-input v-model="bolval"></md-input>
            </md-field>
            <md-button class="button is-rounded is-primary" style="margin-top: -30px; margin-left: 420px;" 
               @click="browseFile" v-if="!isSaveScan && !isCancelScan" :disabled="pauseScan"
               >
               <span>Upload Scan</span>
            </md-button>
            <md-button class="button is-rounded is-primary" style="margin-top: -30px; margin-left: 330px;" 
               @click="saveScan" v-if="isSaveScan && isCancelScan"
               >
               <span>Save</span>
            </md-button>
            <md-button id="cancelscan" class="button is-rounded is-primary" style="margin-top: -30px; margin-left: 10px;" 
               @click="cancelScan" v-if="isCancelScan"
               >
               <span>Cancel Scan</span>
            </md-button>
            <md-button class="button is-rounded is-primary" style="margin-top: -30px; margin-left: 10px;" 
               @click="cancelAction"
               >
               <span>Close</span>
            </md-button>
            <div v-if="preUpload">
            <input type="file" id="scan" name="scan" accept="image/png, image/jpeg" @change="uploadScanPic">
            </div>
         </div> 
           <hr id="pb1"/>
  <md-progress-bar  id="pb" style="display:none" md-mode="indeterminate"/>  
  <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
    <md-button class="md-fab md-primary" @click.prevent="takePhoto" v-if="!isPhotoMode" :disabled="this.isUploadScan">
       <md-tooltip>Take photo and Get BOL</md-tooltip>
       <md-icon>photo_camera</md-icon>
    </md-button>   
  </div>
  <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
    <md-button v-if="isPhotoMode" class="md-fab md-primary" @click.prevent="refreshCamera" :disabled="this.isUploadScan">
       <md-tooltip>Back to video mode</md-tooltip>
       <md-icon>slideshow</md-icon>
    </md-button>   
  </div>
  <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
    <md-button :disabled="!this.isMultiCam" class="md-fab md-primary" @click.prevent="switchCam">
       <md-tooltip>Switch Camera</md-tooltip>
       <md-icon>flip</md-icon>
    </md-button>   
  </div>
  <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
    <md-button :disabled="!this.hasFlashLight" class="md-fab md-primary" @click.prevent="flashLightOnOff">
       <md-tooltip>Turn flash light on off</md-tooltip>
       <md-icon>flash_on</md-icon>
    </md-button>   
  </div> 
  <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
    <md-button :disabled="!isPhotoTaken" class="md-fab md-primary" @click.prevent="saveImage">
       <md-tooltip>save photo</md-tooltip>
       <md-icon>file_upload</md-icon>
    </md-button>   
  </div>

         <video v-show="!isPhotoTaken && !isScanImg" ref="camera" autoplay loop muted height="480" width="640" style="margin-top:-270px"></video>
         <canvas v-show="isPhotoTaken && !isScanImg" id="photoTaken" ref="canvas" height="480" width="640" style="margin-top:-270px"></canvas>
         <img v-if="isScanImg" id="testImg" height="480" width="640" style="margin-top: -260px;">

         <div v-if="hasZoom">
            <input type="range" id="zoom" name="zoom">
         </div>   

      </md-dialog-content>   
   </md-dialog>   
</div>   



<!--
  <div>
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title id="dr_title_Send">Web Cam</md-dialog-title>
        <div id="actionButton" style="margin-top: -50px; margin-left: 250px;">
        <md-progress-bar  id="pb" style="display:none" md-mode="indeterminate"/>
  
            <md-button class="button is-rounded is-primary" 
               @click="cancelAction"
               >
               <span>Cancel</span>
            </md-button>
         </div> 

      <md-dialog-content >

<div id="app" class="web-camera-container">
  <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }">
      <video v-show="!isPhotoTaken" ref="camera" :width="500" :height="800" autoplay loop muted></video>
      <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="500" :height="800"></canvas>
  </div>
  
  <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
    <md-button class="md-fab md-primary" @click.prevent="takePhoto" v-if="!isPhotoMode">
       <md-tooltip>Take photo and Get BOL</md-tooltip>
       <md-icon>photo_camera</md-icon>
    </md-button>   
    <md-button v-if="isPhotoMode" class="md-fab md-primary" @click.prevent="refreshCamera">
       <md-tooltip>Back to video mode</md-tooltip>
       <md-icon>slideshow</md-icon>
    </md-button>   
    <md-button :disabled="!this.isMultiCam" class="md-fab md-primary" @click.prevent="takePhoto">
       <md-tooltip>Switch Camera</md-tooltip>
       <md-icon>flip</md-icon>
    </md-button>   
    <md-button :disabled="!this.hasFlashLight" class="md-fab md-primary" @click.prevent="flashLightOnOff">
       <md-tooltip>Turn flash light on off</md-tooltip>
       <md-icon>flash_on</md-icon>
    </md-button>   
    <md-button :disabled="!isPhotoTaken" class="md-fab md-primary" @click.prevent="downloadImage">
       <md-tooltip>upload photo</md-tooltip>
       <md-icon>file_upload</md-icon>
    </md-button>   

  </div>
  <div>
    <md-textarea v-model="bolval">
    </md-textarea>  
  </div>  
</div>
      </md-dialog-content>
    </md-dialog>
  </div>
-->  
</template>


<style scoped>
/*
.content {
  position: relative;
  width: 500px;
  margin: 0 auto;
  padding: 80px;
}
.content video {
  width: 100%;
  display: block;
}

.content canvas {
  width: 100%;
  display: block;
}

.content:before {
  content: '';
  position: absolute;
  background: rgba(235, 229, 229, 0.5);
  border-radius: 5px;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
*/
.camera-shoot {
   margin-left: 650px;
   /*margin-top: -200px;*/
}

hr {
   width: 100%;
   height: 5px;
   border: 0 none;
   margin-right: auto;
   margin-left: auto;
   margin-top: 10px;
   margin-bottom: 10px;
   background-color:#555;
}

#pb {
   margin-left: auto;
   margin-right: auto;
   margin-top: 10px;
   margin-bottom: 10px;

}

</style>


<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import { minLength, required , maxLength} from 'vuelidate/lib/validators';
  import callingApiCenter from "./CallingApiCenter.vue";
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';
  //import { stream } from 'xlsx/types';


  const SUPPORT_MEDIA_DEVICES = 'mediaDevices' in navigator;
  const savePhotoReq = () => ({
     parentSeqNo: null,
     photoType: null,
     parentType: null,
     photoKey: null,
     refTimeStamp: null,
     image: {
       fileName: null,
       folder: null,
       imageBase64: null,
     },
  });

  export default {
    props: {
      onScan: Function,
    },
    data: () => ({
       savePhotoInfo: savePhotoReq(),
       showDialog: false,
       isCameraOpen: false,
       isPhotoTaken: false,
       isShotPhoto: false,
       isPhotoMode: false,
       isLoading: false,
       isMultiCam: false,
       hasFlashLight: false,
       mdevises: null,
       cameras: [],
       camera: null,
       current_cam: null,
       link: '#',
       camnum: null,
       bolval: null,
       selectedItem: [],
       photoType: null,
       photos: [],
       urlToSave: null,
       getPhotoRequest: null,
       hasZoom: false,
       preUpload: false,
       img: null,
       isScanImg: false,
       isSaveScan: false,
       isCancelScan: false,
       isUploadScan: false,
       pauseScan: false,
    }),


    methods: {
       async openDialog(requestdata, parentPhotoType)
       {
          console.log("open Cam");
          console.log("isPhotoMode: " + this.isPhotoMode);
          if (requestdata != null && requestdata.length > 0) {
             console.log("webcam::inboundShipment: " + requestdata[0].inboundShipment);
             console.log("webcam::bol: " + requestdata[0].bol);
             this.selectedItem = requestdata;
             this.photoType = parentPhotoType;
          }
          await this.detectCam();
          //if (this.cameras.length > 0) {
          //await this.toggleCamera();
          this.showDialog = true;
          //}
          //else {
          //   alert("No camera detected");
          //   return;
         // }
       },

       toggleCamera() {
          if (this.isCameraOpen) {
             this.isCameraOpen = false;
             this.isPhotoTaken = false;
             this.isShotPhoto = false;
             this.isPhotoMode = true;
             this.isScanImg = false;
             this.isSaveScan = false;
             this.isCancelScan = false;
             this.stopCameraStream(); 
          } else {
             this.isCameraOpen = true;
             this.isPhotoMode = false;
             this.isScanImg = false;
             this.isSaveScan = false;
             this.isCancelScan = false;
             console.log("toggleCam::cameras length: " + this.cameras.length);
             this.camera = this.cameras[this.cameras.length -1];
             console.log("toggleCamera::camera deviceId: " + this.camera.deviceId);
             const devId = this.camera.deviceId;
             this.current_cam = devId;
             this.createCameraElement(devId);
             //this.createCameraElement();
          }
       },

       detectCam() {
         console.log("detect cam"); 
         if (SUPPORT_MEDIA_DEVICES) {
           this.mdevices = navigator.mediaDevices.enumerateDevices().then(devices => {
             this.cameras = devices.filter((device) => device.kind === 'videoinput');
             if (this.cameras.length === 0) {
               throw 'No camera found on this device';
             }
             console.log("cameras length: " + this.cameras.length);
             console.log("deviceId: " + this.cameras[0].deviceId);
             if (this.cameras.length === 1) {this.isMultiCam = false; console.log("device has 1 Cam")}
               else {this.isMultiCam = true; console.log("device has multi Cam")}
 
             this.cameras.forEach(
                (it) => {
                  console.log("device id: " + it.deviceId);
                }
             )
             this.toggleCamera();
           })
           

         }
       },

       checkMultiCam() {
         //   this.mdevices = navigator.mediaDevices.enumerateDevices().then(devices => {
         //     this.cameras = devices.filter((device) => device.kind === 'videoinput');
         //     if (this.cameras.length === 0) {
         //       throw 'No camera found on this device';
         //     }
         //     this.camera = this.cameras[this.cameras.length -1];
         //     console.log("camera id: " + this.camera.deviceId + "num of Cam: " + this.cameras.length);
          
       },

       refreshCamera() {
          this.isPhotoTaken = false;
          this.bolval = "";
          this.isPhotoMode = false;
          this.isScanImg = false;
          this.isSaveScan = false;
          this.pauseScan = false;
       },


       refreshCam() {
          console.log("isCameraOpen: " + this.isCameraOpen);
          if (!this.isCameraOpen)
          {
             console.log("turn on Camera");
             this.isCameraOpen = true;
             this.createCameraElement(this.camera.deviceId);
          }   
       },

       createCameraElement(camId) {
          this.isloading = true;
        
         if (SUPPORT_MEDIA_DEVICES) {

            navigator.mediaDevices.getUserMedia({
               video: {
                  deviceId: camId,
                  facingMode: ['user', 'enviornment'],
                  width: { ideal: 1280 },
                  height: { ideal: 1024 }
               }
            }).then(stream => {
               this.isLoading = false;
               this.$refs.camera.srcObject = stream;
               console.log("start stream");
               console.log(navigator.mediaDevices.getSupportedConstraints());
               const track = stream.getVideoTracks()[0];
               const capabilities = track.getCapabilities();
               console.log(track.getCapabilities());
               const settings = track.getSettings();
               console.log(track.getSettings());
               console.log("setting: " + settings.facingMode);
               console.log("setting: " + settings.zoom);
               if ('zoom' in settings)
               {
                  this.hasZoom = true;
                  console.log("zoom start");
                  console.log("zoom min: " + capabilities.zoom.min);
                  input.min = capabilities.zoom.min;
                  console.log("zoom min: " + capabilities.zoom.max);
                  input.max = capabilities.zoom.max;
                  console.log("zoom min: " + capabilities.zoom.step);
                  input.step = capabilities.zoom.step;
                  input.value = settings.zoom;
                  input.oninput = function(event) {
                     track.applyConstraints({advanced: [ {zoom: event.target.value} ]});
                  }
               }
               else
               {
                  this.hasZoom = false;
               }
               
            }
            ) 
         }

         //   this.mdevices = navigator.mediaDevices.enumerateDevices().then(devices => {
         //    this.cameras = devices.filter((device) => device.kind === 'videoinput');
         //    if (this.cameras.length === 0) {
         //      throw 'No camera found on this device';
         //    }
         //    this.camera = this.cameras[this.cameras.length -1];
         //    console.log("camera id: " + this.camera.deviceId + "num of Cam: " + this.cameras.length);
         //    this.camnum = this.cameras.length;

         //    if (this.cameras.length === 1) {this.isMultiCam = false; console.log("device has 1 Cam")}
         //    else {this.isMultiCam = true; console.log("device has multi Cam")}

         //    this.cameras.forEach(
         //      (it) => {
         //        console.log("device id: " + it.deviceId);
         //      }
         //    )
               
         //     navigator.mediaDevices.getUserMedia({
         //       video: {
         //         //deviceId: this.camera.deviceId,
         //         deviceId: camId,
         //         facingMode: ['user', 'enviornment'],
         //         //facingMode: { exact: "left" },
         //         //height: {ideal: 1000},
         //         //maxHeight: 480,
         //         //width: {ideal: 1920}
         //         //maxWidth: 640,
         //         width: { ideal: 1280},
         //         height: { ideal: 1024}
         //       }
         //     }).then(stream => {
         //       this.isLoading = false;
         //       this.$refs.camera.srcObject = stream;
         //       console.log("start steam");
         //       const track = stream.getVideoTracks()[0];
         //       const capabilities = track.getCapabilities();
         //       const settings = track.getSettings();
         //       console.log("setting length: " + settings.length);
         //         settings.forEach(
         //           (it) => {
         //             console.log("setting: " + it);
         //           }
                    
         //         )
         //         const input = document.querySelector('input[type="range"]');
         //         if (!capabilities.torch) {this.hasFlashLight = false; console.log("No torch avaliable"); return;} else {this.hasFlashLight = true;}
         //         track.applyConstraints({advanced: [{ torch: true}]});
         //         if (capabilities.focusMode)
         //         {
         //            console.log("allow manual focus");
         //            track.applyConstraints[{ 
         //               advanced: [{
         //                  focusMode: "manual",
         //                  focusDistance: 5
         //               }]
         //            }]
         //         }
         //         if ('zoom' in settings)
         //         {
         //            console.log("zoom start");
         //            input.min = capabilities.zoom.min;
         //            input.max = capabilities.zoom.max;
         //            input.step = capabilities.zoom.step;
         //            input.value = settings.zoom;
         //            input.oninput = function(event) {
         //               track.applyConstraints({advanced: [ {zoom: event.target.value} ]});
         //            }
         //         }
         //     });
             
         //   }
         //  );
         //}
            

       },

       stopCameraStream() {
          if (this.$refs.camera && this.$refs.camera.srcObject)
          {
            let tracks = this.$refs.camera.srcObject.getTracks();
            console.log("number of tracks: " + tracks.length);
            tracks.forEach(
               track => {
                  track.stop();
                  console.log("track stopped");
               }
            )
          }
       },

       takePhoto() {
          if (!this.isPhotoTaken) {
             this.isShotPhoto = true;
             const FLASH_TIMEOUT = 50;
             setTimeout( () => {
                this.isShotPhoto = false;
             }, FLASH_TIMEOUT);
          }
          this.isPhotoTaken = !this.isPhotoTaken;
          this.pauseScan = true;
          console.log("after take photo isPhotoTaken: " + this.isPhotoTaken);
          const context = this.$refs.canvas.getContext('2d');
          //context.drawImage(this.$refs.camera, 0, 0, 1280, 1024);
          //context.drawImage(this.$refs.camera, 0, 0, 480, 640);
          context.drawImage(this.$refs.camera, 0, 0, 640, 480);
          //context.drawImage(this.$refs.camera, 0, 0, 445, 600);
          //context.drawImage(this.$refs.camera, 0, 0);
          context.font = "24px Comic Sans MS";
          context.fillStyle = "white";
          context.textAlign = "center";
                  var current = new Date();
                  console.log("current date: " + current);
                  var photo_refTimeStamp = (current.getMonth() + 1) + "/" + current.getDate() + "/" + current.getFullYear();

          context.fillText(photo_refTimeStamp, this.$refs.canvas.width - 100, this.$refs.canvas.height - 30);
          console.log("host: " + location.host);
          this.isPhotoMode = true;

          //start text detection
         if (document.getElementById("pb"))
         {
            document.getElementById("pb").style.display = "";
         }
         if (document.getElementById("pb1"))
         {
            document.getElementById("pb1").style.display = "none";
         }
         const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
           .replace("image/jpeg", "image/octet-stream");
         console.log("img: " + canvas);  
         var img = canvas.replace("data:image/octet-stream;base64,","");
         console.log("base64 img: " + img);  
         //const bol = api.post('/api/w/photo/bolDetection', {imageBase64: img})
         const bol = newAPIPost('/api/w/photo/bolDetection', {imageBase64: img})
            .then((it) => {
               this.$store.commit('clearApiError');
               console.log("internal var it length: " + it.length);
               console.log("internal var it: " + it);
               if (it.length > 15)
               {
                  this.bolval = it.toString().substr(1,15)
               }
               else 
               {
                  this.bolval = it;
               }
               console.log("selectedItem length: " + this.selectedItem.length);
               if (document.getElementById("pb"))
               {
                  document.getElementById("pb").style.display = "none";
               }
               if (document.getElementById("pb1"))
               {
                  document.getElementById("pb1").style.display = "";
               }
          })



/*               
               if (this.selectedItem.length > 0) {
                  console.log("bol it: " + it.toString());
                  console.log("selectItem inboundShipment: " + this.selectedItem[0].inboundShipment);
                  console.log("selectedItem parentSeqNo: " + this.selectedItem[0].apptNo);
                  
                  //process to upload image
                  this.savePhotoInfo.parentSeqNo = this.selectedItem[0].apptNo;
                  this.savePhotoInfo.photoType = "BWT";
                  this.savePhotoInfo.parentType = "BWT";
                  this.savePhotoInfo.photoKey = "BWT";
                  var current = new Date();
                  console.log("current date: " + current);
                  this.savePhotoInfo.refTimeStamp = (current.getMonth() + 1) + "/" + current.getDate() + "/" + current.getFullYear();
                  console.log("current date: " + this.savePhotoInfo.refTimeStamp);
                  this.savePhotoInfo.image.folder = `INBOUND/${this.savePhotoInfo.parentSeqNo}`;
                  this.savePhotoInfo.image.fileName = "-BolPicBOLNum.jpg";
                  this.savePhotoInfo.image.imageBase64 = img;

                  
                  console.log("image folder: " + this.savePhotoInfo.image.folder);
                  console.log("Saving photo...");
                  api.post('/api/w/ccic/photo/save', this.savePhotoInfo)
                  .then( (it) => {
                     const requestKey = { seqNo: item.apptNo,sortKey : 'BWT' };
                     this.getPhotoRequest = requestKey;
                     this.photos = this.getPhoto()
                     .then( (it) => {
                         console.log("photos photo length: " + this.photos.phot.length);
                         if (this.photos.photo.length > 0)
                         {
                            this.urlToSave = this.photos.photo[0].photoUrl;
                            console.log("urlToSave: " + this.urlToSave);
                         }
                     }
                     )
                  }
                  )
*/
      },

      saveImage: function() {
               console.log("downloadImage: selectedItem length: " + this.selectedItem.length);
               if (this.selectedItem.length > 0) {
                  if (document.getElementById("pb"))
                  {
                      document.getElementById("pb").style.display = "";
                  }
                  if (document.getElementById("pb1"))
                  {
                     document.getElementById("pb1").style.display = "none";
                  }


                  //console.log("bol it: " + it.toString());
                  console.log("selectItem inboundShipment: " + this.selectedItem[0].inboundShipment);
                  console.log("selectedItem parentSeqNo: " + this.selectedItem[0].apptNo);
                  //process to upload image
                  this.savePhotoInfo.parentSeqNo = this.selectedItem[0].apptNo;
                  //this.savePhotoInfo.photoType = "BWT1";
                  //this.savePhotoInfo.parentType = "BWT1";
                  //this.savePhotoInfo.photoKey = "BWT1";
                  this.savePhotoInfo.photoType = "BWT";
                  this.savePhotoInfo.parentType = "BWT";
                  this.savePhotoInfo.photoKey = "BWT";
                  var current = new Date();
                  console.log("current date: " + current);
                  this.savePhotoInfo.refTimeStamp = (current.getMonth() + 1) + "/" + current.getDate() + "/" + current.getFullYear();
                  console.log("current date: " + this.savePhotoInfo.refTimeStamp);
                  this.savePhotoInfo.image.folder = `INBOUND/${this.savePhotoInfo.parentSeqNo}`;
                  this.savePhotoInfo.image.fileName = "-BolScan.jpg";
                  //this.savePhotoInfo.image.fileName = "-BolPic.jpg";
                  const regex = /image[/](jpeg|png|gif)/i;
                  var canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
                       .replace(regex, "image/octet-stream");
                  //     .replace("image/jpeg", "image/octet-stream");
                  if (this.isScanImg)
                  {
                     console.log("get testImg");
                     canvas = document.getElementById("testImg").src
                       .replace(regex, "image/octet-stream");
                       //.replace("image/jpeg", "image/octet-stream");
                  }     
                  console.log("img: " + canvas);  
                  var img = canvas.replace("data:image/octet-stream;base64,","");
                  console.log("base64 img: " + img);  

                  this.savePhotoInfo.image.imageBase64 = img;

                  
                  console.log("image folder: " + this.savePhotoInfo.image.folder);
                  console.log("Saving photo...");
                  //api.post('/api/w/ccic/photo/save', this.savePhotoInfo)
                  newAPIPost('/api/w/ccic/photo/save', this.savePhotoInfo)
                  .then( (it) => {
                     console.log("done with image saving");
                     //const requestKey = { seqNo: item.apptNo,sortKey : 'BWT' };
                     console.log("set getPhotoRequest");
                     this.onScan(this.bolval, true, this.selectedItem[0].inboundShipment);
                     if (document.getElementById("pb"))
                     {
                        document.getElementById("pb").style.display = "none";
                     }
                     if (document.getElementById("pb1"))
                     {
                        document.getElementById("pb1").style.display = "";
                     }

                     this.cancelAction();
                     /*
                     //this.getPhotoRequest = requestKey;
                     this.getPhotoRequest = { seqNo: item.apptNo,sortKey : 'BWT' };
                     console.log("get photo info");
                     this.photos = this.getPhoto()
                     .then( (it) => {
                         console.log("photos photo length: " + this.photos.phot.length);
                         if (this.photos.photo.length > 0)
                         {
                            this.urlToSave = this.photos.photo[0].photoUrl;
                            console.log("urlToSave: " + this.urlToSave);
                         }
                     }
                     )
                     */
                     // this.onScan(this.bolval, true, this.selectedItem[0].inboundShipment);
   
                     // if (document.getElementById("pb"))
                     // {
                     //    document.getElementById("pb").style.display = "none";
                     // }
                     // if (document.getElementById("pb1"))
                     // {
                     //    document.getElementById("pb1").style.display = "";
                     // }

                     // this.cancelAction();
                  }
                  )
                  //end process upload image
                  // if (document.getElementById("pb"))
                  // {
                  //     document.getElementById("pb").style.display = "none";
                  // }
                  // if (document.getElementById("pb1"))
                  // {
                  //    document.getElementById("pb1").style.display = "";
                  // }

                  // this.onScan(this.bolval, true, this.selectedItem[0].inboundShipment);
                  // this.cancelAction();

                  



               }



         //process to get BOL
         /*
         if (document.getElementById("pb"))
         {
            document.getElementById("pb").style.display = "";
         }
         const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
           .replace("image/jpeg", "image/octet-stream");
         console.log("img: " + canvas);  
         var img = canvas.replace("data:image/octet-stream;base64,","");
         console.log("base64 img: " + img);  
         const bol = api.post('/api/w/photo/bolDetection', {imageBase64: img})
            .then((it) => {
               this.$store.commit('clearApiError');
               console.log("internal var it length: " + it.length);
               console.log("internal var it: " + it);
               this.bolval = it;
               console.log("selectedItem length: " + this.selectedItem.length);
               if (this.selectedItem.length > 0) {
                  console.log("bol it: " + it.toString());
                  console.log("selectItem inboundShipment: " + this.selectedItem[0].inboundShipment);
                  console.log("selectedItem parentSeqNo: " + this.selectedItem[0].apptNo);
                  //process to upload image
                  this.savePhotoInfo.parentSeqNo = this.selectedItem[0].apptNo;
                  this.savePhotoInfo.photoType = "BWT";
                  this.savePhotoInfo.parentType = "BWT";
                  this.savePhotoInfo.photoKey = "BWT";
                  var current = new Date();
                  console.log("current date: " + current);
                  this.savePhotoInfo.refTimeStamp = (current.getMonth() + 1) + "/" + current.getDate() + "/" + current.getFullYear();
                  console.log("current date: " + this.savePhotoInfo.refTimeStamp);
                  this.savePhotoInfo.image.folder = `INBOUND/${this.savePhotoInfo.parentSeqNo}`;
                  this.savePhotoInfo.image.fileName = "-BolPicBOLNum.jpg";
                  this.savePhotoInfo.image.imageBase64 = img;

                  
                  console.log("image folder: " + this.savePhotoInfo.image.folder);
                  console.log("Saving photo...");
                  api.post('/api/w/ccic/photo/save', this.savePhotoInfo)
                  .then( (it) => {
                     const requestKey = { seqNo: item.apptNo,sortKey : 'BWT' };
                     this.getPhotoRequest = requestKey;
                     this.photos = this.getPhoto()
                     .then( (it) => {
                         console.log("photos photo length: " + this.photos.phot.length);
                         if (this.photos.photo.length > 0)
                         {
                            this.urlToSave = this.photos.photo[0].photoUrl;
                            console.log("urlToSave: " + this.urlToSave);
                         }
                     }
                     )
                  }
                  )
                  //end process upload image
                  

                  this.onScan(it.toString(), true, this.selectedItem[0].inboundShipment);
                  if (document.getElementById("pb"))
                  {
                     document.getElementById("pb").style.display = "none";
                  }


               }
            }) 
            */
      },

      getPhoto() {
        //return  api.post('/api/w/gst/photo/get', this.getPhotoRequest)
        return  newAPIPost('/api/w/gst/photo/get', this.getPhotoRequest)
        
      },

      
      cancelAction() {
         this.isCameraOpen = false;
         this.isPhotoTaken = false;
         this.isShotPhoto = false;
         this.bolval = "";
         this.preUpload = false;
         this.isCancelScan = false;
         this.isUploadScan = true;
         this.pauseScan = false;
         this.showDialog = false;
         this.stopCameraStream(); 
      },

      browseFile() {
         console.log("browse file");
         this.preUpload = true;
         this.isCancelScan = true;
         this.isSaveScan = false;
         this.isUploadScan = true;
         this.isPhotoTaken = false;
         this.$nextTick(() => {
            var cancelScan = document.getElementById("cancelscan");
            if (cancelScan)
            {
               console.log("find cancelscan");
               cancelScan.style.marginLeft = "420px";
            }
         })
      },

      saveScan() {
         //this.saveImage()
         //.then(() => {this.isScanImg = false; this.isSaveScan = false;});
         this.saveImage();
         this.isUploadScan = false;
         this.isScanImg = false;
         if (this.isPhotoMode)
            this.isPhotoTaken = false;
         else
            this.isPhotoTaken = true;   
      },

      cancelScan() {
        this.isUploadScan = false;
        this.isSaveScan = false;
        this.isCancelScan = false;
        this.preUpload = false;
        this.isScanImg = false;
        this.isCancelScan = false;
        this.pauseScan = false;
         // if (this.isPhotoMode) {
         //    this.isPhotoTaken = false;
         // }   
         // else {
         //    this.isPhotoTaken = true;   
         // }
         this.isPhotoMode = false;
         this.isPhotoTaken = false;
         this.bolval = "";
         console.log("isPhotoMode: " + this.isPhotoMode + " isPhotoTaken: " + this.isPhotoTaken + " isScanImg: " + this.isScanImg); 
         console.log("isCamerOpen: " + this.isCameraOpen);  
      },

      uploadScanPic: function(e) {
          if (!this.isPhotoTaken) {
             this.isShotPhoto = true;
             const FLASH_TIMEOUT = 50;
             setTimeout( () => {
                this.isShotPhoto = false;
             }, FLASH_TIMEOUT);
          }
          //this.isPhotoTaken = !this.isPhotoTaken;
          this.isScanImg = true;
          //this.isCancelScan = true;
         console.log("upload");
         console.log(document.getElementById("scan"));
         const { files } = e.target;
         var file = null;
         if (files && files[0]) {
            console.log("has file");
            file = files[0];
         };
         console.log("file: " + file);
         this.$nextTick(() => {
            //const canvas = this.$el.querySelector('canvas');
            const canvas = document.getElementById("photoTaken");
            if (canvas) {
               console.log("setup scan image");
               const ctx = canvas.getContext("2d");
               const img = document.createElement("img");

               img.onload = () => {
                  this.img = img;
               };
               var imgSrc = document.getElementById("testImg");
               const reader = new FileReader();
               reader.onload = (e) => {
                  console.log("img src: " + e.target.result);
                  img.src = e.target.result;
                  imgSrc.src = e.target.result;
                  //bol detect
                  if (document.getElementById("pb"))
                  {
                     document.getElementById("pb").style.display = "";
                  }
                  if (document.getElementById("pb1"))
                  {
                     document.getElementById("pb1").style.display = "none";
                  }
                  const regex = /image[/](jpeg|png|gif)/i;
                  const canvas = imgSrc.src.replace(regex, "image/octet-stream");
                  console.log("img1: " + canvas);
                  var img1 = canvas.replace("data:image/octet-stream;base64,","");
                  //api.post('/api/w/photo/bolDetection', {imageBase64: img1})
                  newAPIPost('/api/w/photo/bolDetection', {imageBase64: img1})
                  .then((it) => {
                     this.$store.commit('clearApiError');
                     console.log("internal var it length: " + it.length);
                     console.log("internal var it: " + it);
                     if (it.length > 15)
                     {
                        this.bolval = it.toString().substr(1,15)
                     }
                     else 
                     {
                        this.bolval = it;
                     }
                     //this.bolval = it;
                     if (document.getElementById("pb"))
                     {
                        document.getElementById("pb").style.display = "none";
                     }
                     if (document.getElementById("pb1"))
                     {
                        document.getElementById("pb1").style.display = "";
                     }  

                  })
               };
               reader.readAsDataURL(file);
               ctx.drawImage(img, 0, 0, 640, 480);
               if (document.getElementById("pb"))
               {
                  document.getElementById("pb").style.display = "";
               }
               if (document.getElementById("pb1"))
               {
                  document.getElementById("pb1").style.display = "none";
               }
         
               // if (imgSrc) {
               //    const canvas = imgSrc.src
               //      .replace("image/jpeg", "image/octet-stream");
               //    console.log("img1: " + canvas);  
               //    var img1 = canvas.replace("data:image/octet-stream;base64,","");
               //    console.log("base64 img: " + img1);  
               //    const bol = api.post('/api/w/photo/bolDetection', {imageBase64: img1})
               //      .then((it) => {
               //       this.$store.commit('clearApiError');
               //       console.log("internal var it length: " + it.length);
               //       console.log("internal var it: " + it);
               //       this.bolval = it;
               //       console.log("selectedItem length: " + this.selectedItem.length);
               //       if (document.getElementById("pb"))
               //       {
               //          document.getElementById("pb").style.display = "none";
               //       }
               //    })
               // }
         
            }
            this.isPhotoMode = true;
         })

         this.preUpload = false;
         this.isSaveScan = true;
         this.isCancelScan = false;
         this.isScanImg = true;
         this.isCancelScan = true;
      },

      switchCam() {
         this.stopCameraStream();
         console.log("before current cam id: " + this.current_cam);
         console.log("switchCam::cameras length: " + this.cameras.length);
         for (var i = 0; i < this.cameras.length; ++i)
         {
            console.log("device Id: " + this.cameras[i].deviceId);
            if (this.current_cam != this.cameras[i].deviceId) {
               this.current_cam = this.cameras[i].deviceId;
               break;
            }
         }
            
         console.log("after current cam id: " + this.current_cam);
         this.createCameraElement(this.current_cam);

      },

      flashLightOnOff() {
        
        //  //const SUPPORT_MEDIA_DEVICES = 'mediaDevices' in navigator;
        //  if (SUPPORT_MEDIA_DEVICES) {
        //    this.mdevices = navigator.mediaDevices.enumerateDevices().then(devices => {
        //      this.cameras = devices.filter((device) => device.kind === 'videoinput');
        //      if (this.cameras.length === 0) {
        //        throw 'No camera found on this device';
        //      }
        //      this.camera = this.cameras[this.cameras.length -1];
        //      console.log("camera id: " + this.camera.deviceId + "num of Cam: " + this.cameras.length);
        //      this.camnum = this.cameras.length;

        //      if (this.cameras.length === 1) {this.isMultiCam = false; console.log("device has 1 Cam")}
        //      else {this.isMultiCam = true; console.log("device has multi Cam")}

        //      this.cameras.forEach(
        //        (it) => {
        //          console.log("device id: " + it.deviceId);
        //        }
        //      )
               
        //      navigator.mediaDevices.getUserMedia({
        //        video: {
        //          deviceId: this.camera.deviceId,
        //          facingMode: ['user', 'enviornment'],
        //          height: {ideal: 1000},
        //          width: {ideal: 1920}
        //        }
        //      }).then(stream => {
        //        this.isLoading = false;
        //        this.$refs.camera.srcObject = stream;
        //        const track = stream.getVideoTracks()[0];
        //        //const imageCapture = new ImageCapture(track);
        //        //const photoCapabilities = imageCapture.getPhotoCapabilities().then(() => {
        //          const capabilities = track.getCapabilities();
        //          if (!capabilities.torch) {this.hasFlashLight = false; console.log("No torch avaliable"); return;} else {this.hasFlashLight = true;}
        //          track.applyConstraints({advanced: [{ torch: true}]});
        //          /*
        //          .then(() => {
        //            track.applyConstraints({
        //              advanced: [{torch: true}]
        //            })
        //           */ 
        //           //const btn = document.querySelector('.switch');
        //           //btn.addEventListener('click', function(){
        //           //  track.applyConstraints({
        //           //    advanced: [{torch: true}]
        //           //  });
        //           //});
        //        //});
        //      });
             
        //    }
        //    );
        //  }
        
      },
    }
  }
</script>